import {
    Typography,
    useTheme,
    Box,
    useMediaQuery,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import Reporting from '../HomePage/reportingSmall';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



// Громадським та благодійним організаціям
const ForPublicAndCharitableOrganizations = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "/for-partners" },
        { name: "Громадським та благодійним організаціям", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Громадським та благодійним організаціям`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ mb: { xs: "43px", lg: "120px" } }}>
                <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Box>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", lg: "36px" }} lineHeight="38px">
                    Громадським та благодійним організаціям
                </Typography>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: { xs: "14px", lg: "34px" }, mb: { xs: "43px", lg: "100px" } }}>
                    Ми відкриті до співпраці з громадськими та благодійними організаціями, які поділяють наші цінності й прагнуть сприяти розвитку української культури, молодіжних ініціатив та демократичних цінностей. Разом ми можемо об’єднати ресурси та досвід для реалізації масштабних проєктів, організації культурно-просвітницьких заходів і підтримки вразливих категорій населення.
                    <br /><br />
                    Співпраця з нами передбачає обмін інформацією про можливості, спільне проведення заходів, участь у грантових конкурсах та залучення нових ресурсів. Ми віримо, що разом зможемо досягти більшого, розширивши мережу партнерів і збільшивши позитивний вплив на суспільство.
                </Typography>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Наша звітність */}
                <Reporting />
            </Box>
        </>
    )
}

export default ForPublicAndCharitableOrganizations